/**
 * Image Dimensions Fix (Simplified)
 * This script fixes missing width and height attributes on images to prevent CLS
 * with minimal JavaScript execution during critical loading
 */

// Immediately-invoked function to set critical image dimensions before DOM ready
(function() {
  // Get critical hero image if it exists and set dimensions immediately
  const heroImage = document.querySelector('.hdt-media-wrapper img');
  if (heroImage && (!heroImage.hasAttribute('width') || !heroImage.hasAttribute('height'))) {
    heroImage.setAttribute('width', '1920');
    heroImage.setAttribute('height', '660');
    heroImage.setAttribute('fetchpriority', 'high');
    heroImage.loading = 'eager';
  }
})();

// Cloudflare Images Configuration
const cloudflareConfig = {
  accountId: '02d509343cda1b39d792e11cf60b4089',
  deliveryUrl: 'https://imagedelivery.net/kqtAfraFTcgD333DFm79cw'
};

document.addEventListener('DOMContentLoaded', function() {
  // Add Cloudflare responsive images support
  enhanceWithCloudflareImages();

  // Enhanced function to properly mark LCP image and ensure product images load
  const markLCPImage = () => {
    // Use simplified prioritization - just the main hero in most themes
    const lcpImage = document.querySelector('.hdt-media-wrapper img') || 
                     document.querySelector('.hero-banner img');
    
    if (lcpImage) {
      // Only set high priority if not already done
      if (!lcpImage.hasAttribute('fetchpriority')) {
        lcpImage.setAttribute('fetchpriority', 'high');
        lcpImage.loading = 'eager';
      }
      
      // Only add preload link if it would help
      if (lcpImage.src && !document.querySelector('link[rel="preload"][href="' + lcpImage.src + '"]')) {
        const preloadLink = document.createElement('link');
        preloadLink.rel = 'preload';
        preloadLink.href = lcpImage.src;
        preloadLink.as = 'image';
        document.head.appendChild(preloadLink);
      }
    }

    // Special handling for product pages - make sure first few product images load properly
    const isProductPage = window.location.pathname.includes('/products/');
    if (isProductPage) {
      // Get all product media items
      const productImages = document.querySelectorAll('.hdt-product__media-item img');
      
      // Ensure the first 3 product images load immediately (not lazy)
      productImages.forEach((img, index) => {
        if (index < 3) {
          img.loading = 'eager'; // Force eager loading for first 3 images
          
          // Force display of second image if it might be hidden
          if (index === 1) {
            const mediaItem = img.closest('.hdt-product__media-item');
            if (mediaItem && mediaItem.hasAttribute('hidden')) {
              mediaItem.removeAttribute('hidden');
            }
            if (img.hasAttribute('data-src')) {
              img.src = img.getAttribute('data-src');
            }
          }
        }
      });

      // Also check for any hidden product thumbnails
      const productThumbs = document.querySelectorAll('.hdt-product-media__thumb img');
      productThumbs.forEach((img, index) => {
        if (index < 3) {
          img.loading = 'eager';
          const thumbItem = img.closest('.hdt-slider__slide');
          if (thumbItem && thumbItem.hasAttribute('hidden')) {
            thumbItem.removeAttribute('hidden');
          }
        }
      });
    }
  };

  // Fix slideshow image dimensions to prevent layout shifts
  const fixSlideshowDimensions = () => {
    // Target the main slideshow section
    const mainSlideshow = document.getElementById('shopify-section-template--19342946730219__c28ddbdb-d0df-4b86-9b0a-674df42ecc5c');
    
    if (!mainSlideshow) return;
    
    // Get all images in the slideshow
    const slideshowImages = mainSlideshow.querySelectorAll('.hdt-media-wrapper img');
    
    // Set fixed dimensions based on the container width and desired aspect ratio
    slideshowImages.forEach((img, index) => {
      if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
        // Default aspect ratio of 2.91 (1920/660)
        const aspectRatio = 2.91;
        
        // Set dimensions to prevent layout shifts
        img.setAttribute('width', '1920');
        img.setAttribute('height', '660');
        
        // Set style-based aspect ratio as a fallback
        img.style.aspectRatio = aspectRatio;
        
        // Store the natural dimensions as data attributes
        img.setAttribute('data-natural-width', img.naturalWidth || 1920);
        img.setAttribute('data-natural-height', img.naturalHeight || 660);
        img.setAttribute('data-aspect-ratio', aspectRatio);
        
        // Only prioritize first image, and only if it hasn't been handled already
        if (index === 0 && !img.hasAttribute('fetchpriority')) {
          img.loading = 'eager';
        }
      }
    });
  };
  
  // Fix collection item images specifically to prevent CLS
  const fixCollectionItemDimensions = () => {
    // Target all collection item images
    const collectionImages = document.querySelectorAll('.hdt-collection-img img, .hdt-collection-inner .sqimage-main');
    
    collectionImages.forEach((img, index) => {
      // Set a consistent aspect ratio for collection images
      const aspectRatio = 1; // Square images for collections as per the custom CSS
      
      // If the image doesn't have width/height, set them
      if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
        // Use natural dimensions if available, otherwise use parent container size
        const containerWidth = img.parentElement ? img.parentElement.offsetWidth : 300;
        const width = img.naturalWidth || containerWidth || 300;
        const height = img.naturalHeight || containerWidth || 300; // Force square ratio
        
        img.setAttribute('width', width);
        img.setAttribute('height', height);
        img.style.aspectRatio = aspectRatio;
        
        // Only first 3 images get eager loading - others are lazy
        if (index < 3) {
          img.loading = 'eager';
          // Only first image gets high priority
          if (index === 0 && !img.hasAttribute('fetchpriority')) {
            img.setAttribute('fetchpriority', 'auto');
          }
        } else {
          img.loading = 'lazy';
        }
      }
      
      // Ensure image is visible immediately
      img.style.opacity = '1';
    });
  };
  
  // Improved lazy loading monitoring with immediate setup for product pages
  const setupLazyLoading = () => {
    if (!('IntersectionObserver' in window)) return;
    
    // Function to create and set up the observer
    const createImageObserver = () => {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            // If image has a data-src attribute, set it as the src
            if (img.hasAttribute('data-src')) {
              img.src = img.getAttribute('data-src');
            }
            img.loading = 'eager';
            observer.unobserve(img);
            
            // Also check if parent element has hidden attribute and remove it
            const mediaItem = img.closest('.hdt-product__media-item, .hdt-slider__slide');
            if (mediaItem && mediaItem.hasAttribute('hidden')) {
              mediaItem.removeAttribute('hidden');
            }
          }
        });
      }, {
        rootMargin: '300px 0px', // Increased margin to load earlier
        threshold: 0.01
      });
      
      // Only observe images that are lazy loaded
      document.querySelectorAll('img[loading="lazy"]').forEach(img => {
        imageObserver.observe(img);
      });

      return imageObserver;
    };
    
    // For product pages, set up immediately
    const isProductPage = window.location.pathname.includes('/products/');
    if (isProductPage) {
      const productObserver = createImageObserver();
      
      // Force check visibility for product images that might be hidden
      document.querySelectorAll('.hdt-product__media-item[hidden] img, .hdt-slider__slide[hidden] img').forEach(img => {
        if (!img.complete) {
          img.onload = () => {
            const mediaItem = img.closest('.hdt-product__media-item, .hdt-slider__slide');
            if (mediaItem) {
              mediaItem.removeAttribute('hidden');
            }
          };
        }
      });
    } else {
      // For other pages, delay to not impact critical content
      setTimeout(createImageObserver, 800);
    }
  };
  
  // Fix all other images on the page
  const fixAllImageDimensions = () => {
    // Get all images without width or height
    const images = document.querySelectorAll('img:not([width]):not([height])');
    
    images.forEach(img => {
      // Wait for image to load to get natural dimensions
      if (img.complete) {
        setImageDimensions(img);
      } else {
        img.addEventListener('load', function() {
          setImageDimensions(img);
        });
      }
    });
  };
  
  // Helper function to set dimensions
  const setImageDimensions = (img) => {
    if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
      // Use natural dimensions if available
      if (img.naturalWidth && img.naturalHeight) {
        img.setAttribute('width', img.naturalWidth);
        img.setAttribute('height', img.naturalHeight);
        
        // Calculate and store aspect ratio
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        img.setAttribute('data-aspect-ratio', aspectRatio);
        img.style.aspectRatio = aspectRatio; // Apply aspect ratio via CSS for browser support
      } else {
        // Default dimensions if natural dimensions aren't available
        img.setAttribute('width', '100%');
        img.setAttribute('height', 'auto');
        img.style.aspectRatio = '16/9';
      }
      
      // Set appropriate loading attribute based on position
      if (isInViewport(img)) {
        img.loading = 'eager'; // For visible images
      } else {
        img.loading = 'lazy'; // For below-the-fold images
      }
    }
  };
  
  // Helper function to check if element is in viewport with a buffer zone
  const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= -200 && // Include elements just above viewport (200px)
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight + 200 || document.documentElement.clientHeight + 200) && // Include elements just below viewport (200px)
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  
  /**
   * Enhance images with Cloudflare responsive images
   * This adds responsive image support using either Shopify CDN or Cloudflare
   */
  function enhanceWithCloudflareImages() {
    // Target collection and product images that should be responsive
    const responsiveImageSelectors = [
      '.hdt-collection-img img',          // Collection images
      '.hdt-card-product__media img',     // Product card images
      '.product__media img',              // Product page images
      '.featured-product__photos img'     // Featured product images
    ];
    
    // Find all target images
    const responsiveImages = document.querySelectorAll(responsiveImageSelectors.join(', '));
    
    responsiveImages.forEach(function(img) {
      // Skip already processed images
      if (img.dataset.responsiveProcessed === 'true') return;
      
      // Mark as processed to avoid duplicate processing
      img.dataset.responsiveProcessed = 'true';
      
      // Only process if this is a Shopify CDN image
      if (img.src && img.src.includes('cdn.shopify.com')) {
        applyResponsiveAttributes(img);
      }
    });
    
    // Set up observer to catch dynamically loaded images
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            // Check if the added node is an image or contains images
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'IMG') {
                processNewImage(node);
              } else {
                // Check if the added element contains images
                const images = node.querySelectorAll('img');
                images.forEach(processNewImage);
              }
            }
          });
        }
      });
    });
    
    // Start observing the document
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Process a newly added image
    function processNewImage(img) {
      // Skip already processed images
      if (img.dataset.responsiveProcessed === 'true') return;
      
      // Mark as processed to avoid duplicate processing
      img.dataset.responsiveProcessed = 'true';
      
      // Only process if this is a Shopify CDN image
      if (img.src && img.src.includes('cdn.shopify.com')) {
        applyResponsiveAttributes(img);
      }
    }
    
    // Apply responsive srcset and sizes attributes to an image
    function applyResponsiveAttributes(img) {
      // Skip SVGs and placeholder images
      if (img.src.endsWith('.svg') || img.classList.contains('hdt-placeholder-svg')) {
        return;
      }
      
      // Get the base URL without query parameters
      const baseUrl = img.src.split('?')[0];
      
      // Generate the srcset with multiple width variations
      const srcset = [
        `${baseUrl}?width=320&crop=center&format=pjpg&auto=webp 320w`,
        `${baseUrl}?width=640&crop=center&format=pjpg&auto=webp 640w`,
        `${baseUrl}?width=960&crop=center&format=pjpg&auto=webp 960w`,
        `${baseUrl}?width=1280&crop=center&format=pjpg&auto=webp 1280w`,
        `${baseUrl}?width=1920&crop=center&format=pjpg&auto=webp 1920w`
      ].join(', ');
      
      // Determine appropriate sizes based on the image's container context
      let sizes = '(min-width: 1150px) 25vw, (min-width: 768px) 33vw, 50vw';
      
      // Customize sizes based on where the image appears - using 5 columns on desktop as per memory
      if (img.closest('.hdt-collection-img')) {
        // Collection image - 5 columns on desktop per memory
        sizes = '(min-width: 1150px) calc(20% - 24px), (min-width: 768px) calc(33.333% - 20px), calc(50% - 16px)';
      } else if (img.closest('.product__media') || img.closest('.featured-product__photos')) {
        // Product images
        sizes = '(min-width: 768px) 50vw, 100vw';
      } else if (img.closest('.hdt-slider__slide')) {
        // Slider images
        sizes = '(min-width: 1150px) 33vw, (min-width: 768px) 50vw, 100vw';
      }
      
      // Apply the attributes
      img.srcset = srcset;
      img.sizes = sizes;
      
      // Ensure loading is appropriate
      if (!img.loading) {
        img.loading = 'lazy';
      }
    }
  }
  
  // Run fixes in a sequence that prioritizes critical content first
  // and delays less important operations
  
  // Critical path - do this first
  markLCPImage();
  fixSlideshowDimensions();
  
  // Check if we're on a product page for special handling
  const isProductPage = window.location.pathname.includes('/products/');
  
  if (isProductPage) {
    // EMERGENCY FIX FOR PRODUCT PAGES - force second image to be visible immediately
    const productImages = document.querySelectorAll('.hdt-product__media-item img');
    productImages.forEach((img, index) => {
      // Force first 3 images to load eagerly
      if (index < 3) {
        img.loading = 'eager';
        
        // Special focus on second image
        if (index === 1) {
          const mediaItem = img.closest('.hdt-product__media-item');
          if (mediaItem) {
            // Remove any hidden attribute
            if (mediaItem.hasAttribute('hidden')) {
              mediaItem.removeAttribute('hidden');
            }
            // Force display by setting style explicitly
            mediaItem.style.display = 'block';
          }
          // If there's a data-src attribute, apply it immediately
          if (img.hasAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
          }
        }
      }
    });
    
    // Also fix any thumbnails
    document.querySelectorAll('.hdt-product-media__thumb .hdt-slider__slide').forEach((slide, index) => {
      if (index < 3 && slide.hasAttribute('hidden')) {
        slide.removeAttribute('hidden');
      }
    });
    
    // Set up lazy loading immediately for product pages
    setupLazyLoading();
  }
  
  // Slightly less critical - do after a minimal delay
  setTimeout(() => {
    fixCollectionItemDimensions();
    fixAllImageDimensions();
  }, 200);
  
  // Set up lazy loading with reduced delay
  setTimeout(() => {
    // Only set up lazy loading here if we're not on a product page (already done above)
    if (!isProductPage) {
      setupLazyLoading();
    }
  }, 300);
  
  // Run again after page load to catch any dynamically loaded images
  window.addEventListener('load', () => {
    // Special handling for product pages
    if (isProductPage) {
      // Force check product images again
      document.querySelectorAll('.hdt-product__media-item[hidden]').forEach(item => {
        item.removeAttribute('hidden');
        item.style.display = 'block';
      });
    }
    
    fixSlideshowDimensions();
    fixCollectionItemDimensions();
    fixAllImageDimensions();
  });
});

// Also run on window load to catch late-loading images
window.addEventListener('load', function() {
  // Fix for lightbox/zoom images not showing
  fixLightboxZoomImages();
  
  // Get all images in the main slideshow
  const mainSlideshow = document.getElementById('shopify-section-template--19342946730219__c28ddbdb-d0df-4b86-9b0a-674df42ecc5c');
  
  if (mainSlideshow) {
    const slideshowContainer = mainSlideshow.querySelector('.hdt-slider__viewport');
    
    // If we have the container, ensure it has a minimum height
    if (slideshowContainer) {
      const containerWidth = slideshowContainer.offsetWidth;
      const aspectRatio = 2.91; // 1920/660
      const calculatedHeight = containerWidth / aspectRatio;
      
      // Set a minimum height to prevent layout shifts
      slideshowContainer.style.minHeight = `${calculatedHeight}px`;
    }
  }
  
  // Re-run collection image fixes on load to ensure they're applied
  fixCollectionItemDimensions();
  
  // Load Cloudflare uploader for admin users
  if (window.Shopify && window.Shopify.designMode) {
    loadCloudflareAdminScript();
  }
  
  // Additional check for collection page
  const collectionGrid = document.querySelector('.hdt-collection-products');
  if (collectionGrid) {
    // Set a min-height on the container to prevent CLS
    const gridItems = collectionGrid.querySelectorAll('.hdt-collection-item');
    if (gridItems.length > 0) {
      // Add a small script to watch for lazy-loaded images and update them
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target.querySelector('img');
            if (img && img.loading === 'lazy') {
              // When image becomes visible, prioritize loading
              img.loading = 'eager';
            }
          }
        });
      }, { rootMargin: '200px' }); // Start loading 200px before it comes into view
      
      gridItems.forEach(item => observer.observe(item));
    }
  }
});

// Add a resize handler to recalculate dimensions
window.addEventListener('resize', debounce(function() {
  fixSlideshowDimensions();
  fixCollectionItemDimensions();
}, 250));

// Simplified function to fix ONLY the lightbox/zoom issue with the second image
function fixLightboxZoomImages() {
  // Check if we're on a product page
  const isProductPage = window.location.pathname.includes('/products/');
  if (!isProductPage) return;
  
  console.log('Fixing product lightbox images...');
  
  // Direct fix for the second product image - ONLY target what's needed
  const secondProductImage = document.querySelector('.hdt-product__media-item:nth-child(2), .hdt-slider__slide:nth-child(2)');
  if (secondProductImage) {
    // Make the second image visible
    secondProductImage.removeAttribute('hidden');
    secondProductImage.style.display = 'block';
    
    // Make sure the image inside is loaded
    const img = secondProductImage.querySelector('img');
    if (img) {
      img.loading = 'eager'; // Force eager loading
      if (img.hasAttribute('data-src')) {
        img.src = img.getAttribute('data-src');
      }
    }
  }
  
  // Quick fix for zoom containers
  document.querySelectorAll('.zoomContainer, .zoomWindow, .hdt-produc-zoom--wrapp').forEach(container => {
    const zoomImages = container.querySelectorAll('img');
    zoomImages.forEach(img => {
      // Make sure zoom images load
      img.loading = 'eager';
      if (img.hasAttribute('data-src')) {
        img.src = img.getAttribute('data-src');
      }
    });
  });
  
  // Add click handler to product images to ensure zoom works
  document.querySelectorAll('.hdt-product__media-item img').forEach(img => {
    img.addEventListener('click', function() {
      // Fix zoom images after a small delay to let zoom initialize
      setTimeout(() => {
        document.querySelectorAll('.zoomContainer img, .zoomWindow img').forEach(zoomImg => {
          zoomImg.loading = 'eager';
          if (zoomImg.hasAttribute('data-src')) {
            zoomImg.src = zoomImg.getAttribute('data-src');
          }
        });
      }, 50);
    });
  });
}

// Simple debounce function to prevent excessive function calls
function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// Helper function to load admin script for Cloudflare uploader
function loadCloudflareAdminScript() {
  console.log('Loading Cloudflare Image Uploader for admin...');
  const script = document.createElement('script');
  script.src = window.theme?.assets_url + '/cloudflare-image-uploader.js' || '/assets/cloudflare-image-uploader.js';
  script.defer = true;
  document.body.appendChild(script);
}
